// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const serviceUrl = "/api/str/PipeAndWireSheetPricing";
const pricesUrl = `${serviceUrl}/GetRealTimePrices`;
const sendEmailUrl = `${serviceUrl}/SendEmail`;
const subscribeUrl = `${serviceUrl}/Subscribe`;
const unSubscribeUrl = `${serviceUrl}/Unsubscribe`;

export interface GetPricesApiParameter extends ApiParameter {
    productsIds?: string[];
}

export interface ProductModel {
    description?: string;
    price?: string;
    productNumber?: string;
    urlSegment?: string;
}

export interface ProductListModel {
    products?: ProductModel[];
}

export interface GetPricesApiModel {
    asOfDate?: string;
    productList?: ProductListModel;
    productMatchErrors?: string;
    subscribedToPipeAndWireSheetEmail?: boolean;
    successful?: boolean;
}

export interface SendEmailWithSheetApiParameter extends ApiParameter {
    message?: string;
    email?: string;
}

export async function getPricesApi(parameter: GetPricesApiParameter): Promise<GetPricesApiModel> {
    const result = await post<string[], GetPricesApiModel>(`${pricesUrl}`, parameter.productsIds);
    return result;
}

export async function sendEmailWithSheetApi(parameter: SendEmailWithSheetApiParameter) {
    const result = await post<SendEmailWithSheetApiParameter, ServiceResult<void>>(`${sendEmailUrl}`, {
        message: parameter.message,
        email: parameter.email,
    });
    return result;
}

export async function subscribeApi(): Promise<ServiceResult<void>> {
    const result = await post<ServiceResult<void>>(`${subscribeUrl}`);
    return result;
}

export async function unsubscribeApi(): Promise<ServiceResult<void>> {
    const result = await post<ServiceResult<void>>(`${unSubscribeUrl}`);
    return result;
}
